// React
import React from 'react';
import PropTypes from 'prop-types';

import { css } from '@emotion/core';

import CybsCombobox from '@cybs-ui/components/lib/combobox';

class Combobox extends React.Component {
  constructor(props) {
    super(props);

    this.types = {
      SINGLE: 'single',
      MULTI: 'multi'
    };
    const { i18n, isInputInvalid, errorText } = this.props;
    this.state = {
      errorMessage: errorText || i18n.inputErrorText || '',
      isInputInvalid
    };
  }

  componentDidUpdate(prevProps) {
    const { isInputInvalid, i18n } = this.props;
    if (prevProps.isInputInvalid !== isInputInvalid) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isInputInvalid
      });
    }
    if (prevProps?.i18n?.inputErrorText !== i18n?.inputErrorText) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        errorMessage: i18n.inputErrorText
      });
    }
  }

  onClose = () => {
    const { selectedItems } = this.state;
    const { onCellChange, cell, rowIdx, colIdx, variant } = this.props;
    if (variant === this.types.MULTI) {
      cell.active = true;
      onCellChange(selectedItems, cell, rowIdx, colIdx);
    }
  };

  handleChange = (e, selected) => {
    const { onCellChange, cell, rowIdx, colIdx, variant } = this.props;
    this.setState(
      {
        selectedItems: selected,
        errorMessage: '',
        isInputInvalid: false
      },
      () => {
        if (variant !== this.types.MULTI) {
          cell.active = true;
          onCellChange(selected, cell, rowIdx, colIdx);
        }
      }
    );
  };

  handleInputBlur = (event, isInputInvalid, selectedItems) => {
    const { onBlur, i18n, required } = this.props;
    if (isInputInvalid) {
      if (event.target.value === '' && !required) {
        this.setState({ errorMessage: '', isInputInvalid: false });
      } else {
        this.setState({
          errorMessage: i18n.noResults || Combobox.defaultProps.i18n.noResults,
          isInputInvalid: true
        });
      }
    } else {
      this.setState({ errorMessage: '', isInputInvalid: false });
    }
    if (typeof onBlur === 'function') {
      onBlur(event, isInputInvalid, selectedItems);
    }
  };

  render() {
    const {
      colIdx,
      dataTest,
      errorText,
      filterFunction,
      i18n: i18nProp,
      label,
      onBlur,
      options,
      placeholder,
      required,
      rowIdx,
      tableId,
      type,
      width,
      value,
      variant,
      ...rest
    } = this.props;
    const i18n = {
      ...Combobox.defaultProps.i18n,
      ...i18nProp
    };

    const items = options;
    const { errorMessage, isInputInvalid } = this.state;

    const ariaLabelName = i18n.ariaLabel || i18n.label || label;

    return (
      <CybsCombobox
        customCSS={() => css`& .vds-input:not(.vds-state--filled) span.vds-input-hint { display: block; }`}
        dataTest={dataTest}
        inputProps={{
          placeholder,
          id: `${tableId}-${rowIdx}-${colIdx}`
        }}
        i18n={{
          inputErrorText: errorMessage,
          ariaLabel: `${ariaLabelName} ${i18n.filter}`,
          label: i18n.label
        }}
        items={items}
        onClose={this.onClose} // for multi
        onSelect={this.handleChange}
        searchKey="label"
        selectedItems={value}
        type={variant}
        width={`${width}px`}
        onBlur={this.handleInputBlur}
        required={required}
        filterFunction={filterFunction}
        useNativePlaceholder={false}
        {...rest}
        isInputInvalid={isInputInvalid}
        tableId={tableId}
      />
    );
  }
}
Combobox.displayName = 'Gridtable Combobox';

Combobox.propTypes = {
  colIdx: PropTypes.number.isRequired,
  cell: PropTypes.shape({ active: PropTypes.bool }).isRequired,
  dataTest: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  filterFunction: PropTypes.func,
  i18n: PropTypes.shape({
    filter: PropTypes.string,
    inputErrorText: PropTypes.string,
    noResults: PropTypes.string,
    label: PropTypes.string,
    ariaLabel: PropTypes.string
  }),
  isInputInvalid: PropTypes.bool,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onCellChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  rowIdx: PropTypes.number.isRequired,
  tableId: PropTypes.string.isRequired,
  type: PropTypes.string,
  width: PropTypes.number,
  value: PropTypes.string,
  variant: PropTypes.string
};

Combobox.defaultProps = {
  errorText: '',
  i18n: {
    filter: 'filter',
    inputErrorText: '',
    noResults: 'No results found.',
    label: undefined,
    ariaLabel: undefined
  },
  required: false,
  isInputInvalid: undefined,
  label: '',
  onCellChange: () => {},
  options: undefined,
  placeholder: undefined,
  type: undefined,
  width: 180,
  value: undefined,
  variant: undefined,
  onBlur: () => {},
  filterFunction: null
};

export default Combobox;
